export default () => ({
  isLoaded: false,

  record: null,
  original: null,
  modified: null
})
